import type { TechnologyOption } from './types/siteData'

export const DEBUG = process.env.REACT_APP_DEBUG === 'true'
export const SHOW_ONLY_PUBLISHED =
  process.env.REACT_APP_SHOW_ONLY_PUBLISHED === 'true'
export const BYPASS_RECAPTCHA =
  process.env.REACT_APP_BYPASS_RECAPTCHA === 'true'
export const REACT_APP_API_TOKEN = process.env.REACT_APP_API_TOKEN
export const NAV_ID = process.env.REACT_APP_NAV_ID

export const SERVER = process.env.REACT_APP_SERVER

export const SMARTMED_EMAIL = 'info@healthxchangedevices.com'
export const SMARTMED_PHONE_NUMBER = '(+44)0808 1968 084'

export const IS_CAROUSEL_ENABLED = true
export const IS_CLINIC_FINDER_ENABLED = false

/**
 * Fallback device list for contact forms when CMS data is unavailable.
 * Keep in sync with live product pages under /products/*.
 */
export const DEFAULT_TECHNOLOGIES: TechnologyOption[] = [
  { slug: 'inshape', value: 'InShape' },
  { slug: 'medilux', value: 'MediLUX' },
  { slug: 'observ', value: 'OBSERV' },
  { slug: 'potenza', value: 'POTENZA' },
  { slug: 'ultralux-pro', value: 'UltraLUX Pro' },
]
